import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {FilterUtil} from '../../../util/filter.util';
import {RequestType} from '../../../enums/request.type';
import {ListResponse} from '../../../network/service/list.response';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {VerifyOptions} from '../../dialog/verify/options/verify.options';
import {VerifyComponent} from '../../dialog/verify/verify.component';
import {DataResponse} from '../../../network/service/data.response';
import {AddOrUpdateTagOptions} from '../dialog/add-or-update-tag/options/add-or-update-tag.options';
import {AddOrUpdateTagComponent} from '../dialog/add-or-update-tag/add-or-update-tag.component';

@Component({
  selector: 'app-tags',
  standalone: false,
  templateUrl: './tags.component.html',
  styleUrl: './tags.component.scss'
})
export class TagsComponent extends BaseComponent implements OnInit {
  displayedColumns = ['Update', 'Delete', 'Title', 'IsActive', 'Image'];
  displayDataSources = ['edit', 'delete', 'Title', 'IsActiveIcon', 'Icon'];
  displayColumnTypes = ['event', 'event', 'string', 'icon', 'image'];
  displayEndPoint = ['', ''];
  tags: any = [];
  allFilters = FilterUtil.DeliveryMethodsFilters;
  filters: any = {};

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getTags(this.tableProperties.offset, this.tableProperties.limit, '', RequestType.PAGINATE, undefined, {
      Filter: this.filters,
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.tags = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    if (this.tags) {
      for (let i = 0; i < this.tags.length; i++) {
        this.tags[i].edit = (index: number) => {
          this.onUpdateClicked(index);
        };
        this.tags[i].delete = (index: number) => {
          this.onDeleteClicked(index);
        };
        if (this.tags[i].IsActive === true) {
          this.tags[i].IsActiveIcon = 'check_circle-green';
        } else {
          this.tags[i].IsActiveIcon = 'do_not_disturb-red';
        }
      }
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onCreateClicked() {
    let addOrUpdateTagOptions = new AddOrUpdateTagOptions();
    addOrUpdateTagOptions.tag = {};
    addOrUpdateTagOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateTagComponent = this.matDialog.open(AddOrUpdateTagComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateTagComponent.componentInstance.addOrUpdateTagOptions = addOrUpdateTagOptions;
  }

  onUpdateClicked(index: number) {
    let addOrUpdateTagOptions = new AddOrUpdateTagOptions();
    addOrUpdateTagOptions.tag = this.tags[index];
    addOrUpdateTagOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateTagComponent = this.matDialog.open(AddOrUpdateTagComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateTagComponent.componentInstance.addOrUpdateTagOptions = addOrUpdateTagOptions;
  }

  onDeleteClicked(index: number) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف درخواست خود مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteTags(this.tags[index].TagId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadOnline();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }
}
